import type { ToolCallData } from '@shared/services/conversationApiService/types';

export interface ToolCallMetadata {
  descriptionKey: string;
}

const EXTERNAL_TOOL_METADATA: ToolCallMetadata = {
  descriptionKey: 'campaignPage.toolCall.metadata.externalTool',
};

const INTERNAL_TOOL_METADATA: ToolCallMetadata = {
  descriptionKey: 'campaignPage.toolCall.metadata.internalTool',
};

const FOLLOW_UP_MESSAGE_METADATA: ToolCallMetadata = {
  descriptionKey: 'campaignPage.toolCall.metadata.sendFollowUpMessage',
};

const TOOL_CALL_METADATA: Record<string, ToolCallMetadata> = {
  end_call: { descriptionKey: 'campaignPage.toolCall.metadata.endCall' },
  donot_call: { descriptionKey: 'campaignPage.toolCall.metadata.doNotCall' },
  call_handoff_signal: { descriptionKey: 'campaignPage.toolCall.metadata.callHandoff' },
  send_follow_up_message: FOLLOW_UP_MESSAGE_METADATA,
  request_callback: { descriptionKey: 'campaignPage.toolCall.metadata.requestCallback' },
  transfer_call: { descriptionKey: 'campaignPage.toolCall.metadata.transferCall' },
  whatsapp_message_send: FOLLOW_UP_MESSAGE_METADATA,
};

export const resolveToolCallMetadata = (
  name: string,
  source: ToolCallData['source'],
): ToolCallMetadata => {
  if (source !== 'local') return EXTERNAL_TOOL_METADATA;

  return TOOL_CALL_METADATA[name] ?? INTERNAL_TOOL_METADATA;
};
